//TODO:  Is ep-filter-input the right name for the selector?
//video where concept came from: https://egghead.io/lessons/angular-2-filter-items-with-a-custom-search-pipe-in-angular-2

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterType } from '@Shared/Pipes/proprietary/filter.pipe';

@Component({
    standalone: false,
    selector: 'ep-filter-input',
    template: `
    <div class="unity-form-group mb-1" style="width: 180px">
      <input
        #input
        type="text"
        (input)="onChange(input.value)"
        placeholder="quick filter"
        style="padding-right:20px;"
      />
      <svg
        *ngIf="filter.filterText || filter.filterText > ' '"
        class="unity-icon unity-icon-lg unity-icon-times"
        style="color:grey; position:absolute; cursor: pointer; right: 0.25rem"
        (click)="input.value = ''; onChange('')"
      >
        <use xlink:href="#unity-icon-times"></use>
      </svg>
    </div>
  `
})
export class FilterInputComponent {
    @Output() itemChanged = new EventEmitter();

    @Input()
    filter: FilterType;

    ngOnInit() {
        this.itemChanged.emit(this.filter);
    }

    onChange(value: string) {
        this.filter.filterText = value;
        this.itemChanged.emit(this.filter);
    }

    clear() {
        this.filter.filterText = '';
        this.itemChanged.emit(this.filter);
    }
}
